define('views/layouts/content/layout-info-stack',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/layout',
    // views
    'views/layouts/layout-overlay-stack',
    'views/layouts/content/layout-info-overlay'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    LayoutState,
    // views
    VLayoutOverlayStack,
    VLayoutInfoOverlay
) {

    var VLayoutInfoStack = VLayoutOverlayStack.extend({
        overlay: VLayoutInfoOverlay,

        initialize: function(opt) {
            this.listenTo(LayoutState, { "stack:info": this.push });
        },
    });

    return VLayoutInfoStack;
});

